const reservedColorList = ["#ddebf7", "#fff2cc", "#fce4d6", "#C5C5C5"];
const unreservedColor = "#e2efda";
const availableText = "Available";

/**
 * The inline style definition for sort grid allocation table
 * @param color
 * @returns {{border: string, borderCollapse: string, backgroundColor, textAlign: string}}
 */
export function getTableStyle(color) {
    return {
        'border': '1px solid grey',
        'borderCollapse': 'collapse',
        'textAlign': 'center',
        'backgroundColor': color
    };
}

/**
 * Comparison logic for sorting two aisles based on sortIndex
 * @param aisle1
 * @param aisle2
 * @returns {number}
 */
export function compareAisleInfoForSorting(aisle1, aisle2) {
    let aisle1Index = aisle1.sortIndex;
    let aisle2Index = aisle2.sortIndex;
    return aisle1Index > aisle2Index ? 1 : -1;
}

/**
 * From a list of sort locations, create a top-down model for rendering
 * @param sortLocations
 * @returns {*}
 */
export function unFlattenSortLocationsModel(sortLocations) {
    const clusterInfoMap = {};
    const colorMapping = {};
    let lastUsedColorIndex = -1;

    function getColorForReservingEntity(reservedFor) {
        if(!(reservedFor in colorMapping)) {
            // get new color
            const newColorIndex = getRotatingIndex(lastUsedColorIndex, reservedColorList.length);
            colorMapping[reservedFor] = reservedColorList[newColorIndex];
            lastUsedColorIndex = newColorIndex;
        }
        return colorMapping[reservedFor];
    }

    if(sortLocations) {
        for (const sortLocationInfo of sortLocations) {
            let sortLocationLabel = sortLocationInfo.label;
            let aisleLabel = sortLocationInfo.aisle;
            let clusterLabel = getClusterLabelFromAisle(aisleLabel);
            let columnLabel = getColumnLabelFromSortLocation(sortLocationLabel);

            if(!(clusterLabel in clusterInfoMap)) {
                clusterInfoMap[clusterLabel] = getSkeletonClusterInfo(clusterLabel);
            }

            let aisleInfoMap = clusterInfoMap[clusterLabel].aisleInfoMap;
            let aisleInfo = (!(aisleLabel in aisleInfoMap)) ?
                getSkeletonAisleInfo(aisleLabel) : aisleInfoMap[aisleLabel];

            // push the sort location info in aisle object
            if(!(columnLabel in aisleInfo.sortLocations)) {
                aisleInfo.sortLocations[columnLabel] = [];
            }

            // mark the aisle as reserved if the sort location is reserved.
            if (sortLocationInfo.status === "RES") {
                let color = getColorForReservingEntity(sortLocationInfo.reservedFor);
                aisleInfo.sortLocations[columnLabel].push(getReservedSortLocationInfo(sortLocationInfo, color));
                aisleInfo.reservedFor = sortLocationInfo.reservedFor;
                aisleInfo.color = color;
            } else {
                aisleInfo.sortLocations[columnLabel].push(getAvailableSortLocationInfo(sortLocationInfo));
            }

            clusterInfoMap[clusterLabel].aisleInfoMap[aisleLabel] = aisleInfo;
        }
    }

    return clusterInfoMap;
}

function getSkeletonClusterInfo(clusterLabel) {
    return {
        "label" : clusterLabel,
        "aisleInfoMap" : {}
    };
}

function getSkeletonAisleInfo(aisleLabel) {
    return {
        "sortIndex": getAisleSortIndex(aisleLabel),
        "label": aisleLabel,
        "color": unreservedColor,
        "reservedFor": availableText,
        "sortLocations": {}
    };
}

function getAvailableSortLocationInfo(sortLocationInfo) {
    return {
        "label": sortLocationInfo.label,
        "reservedFor": availableText,
        "color" : unreservedColor
    };
}


function getReservedSortLocationInfo(sortLocationInfo, color) {
    return {
        "label": sortLocationInfo.label,
        "reservedFor": sortLocationInfo.reservedFor,
        "color" : color
    };
}

function getRotatingIndex(lastUsedIndex, boundLength) {
    let newIndex = lastUsedIndex + 1;
    if(newIndex > boundLength-1) {
        newIndex = 0;
    }

    return newIndex;
}

/**
 * get cluster label from aisle.
 * @param aisleLabel
 * @returns {*|string}
 */
function getClusterLabelFromAisle(aisleLabel) {
    return aisleLabel ? aisleLabel[0] : "Unknown";
}

/**
 * get column label from sort location
 * @param sortLocationLabel
 * @returns {*|string}
 */
function getColumnLabelFromSortLocation(sortLocationLabel) {
    return sortLocationLabel.charAt(sortLocationLabel.length - 1);
}

/**
 * Get sort index for an aisle for sorting while displaying
 * @param aisleLabel
 * @returns {number|number}
 */
function getAisleSortIndex(aisleLabel) {
    let matches = aisleLabel.match(/(\d+)/);
    return matches.length > 0 ? parseInt(matches[0], 10) : 0;
}



// WEBPACK FOOTER //
// ./src/components/utils/GridAllocationUtil.js